
// import { useEffect, useState } from "react";
// import Global from "../../pages/component/Global";
// import data from "../../utils/constants/indonesia";
import Card from "../Card/Card";
import styles from "./Two.module.css";
// import { fetchData } from "../../pages/component/Global";
// import axios from "axios";




function Two() {
    // const two =  data;


    // const atas = (
    //     <div className={styles.cards__one}>
    //         {props.data.map((post) => 
    //             <h1 key={post.status}>{post.status}</h1>
                
    //         ) }
 
    //     </div> 
    // );


    // const bawah = (
    //     <div className={styles.cards__one}>
    //         {props.data.map((post) => 
    //             <h1 className={styles.cards__descOne} value="" key={post.total}>{post.total}</h1>
                
    //         ) }
            
    //     </div> 
    // );

    //19:57
   
// const [sum, setSum] = useState('');

// async function fetchData(){
//     const response = await fetch( 
//         "https://covid19.mathdro.id/api/"

//     );

//     const data = await response.json();
//     // console.log(data);

//     setSum(data);

//     const { data : {confirmed, recovered, deaths, lastUpdate}} = await axios(URL);
//     // console.log(confirmed);

//     return { confirmed, recovered, deaths, lastUpdate };

    // if(!data.confirmed){
    //     return 'Loading...';
    // }

    // const modifiedData = {
    //     confirmed: confirmed,
    //     recovered: recovered,
    //     deaths: deaths,
    //     lastUpdate: lastUpdate,

        
    // }


    // return modifiedData;

    // this.setSum({data : fetchData});
// }

// console.log(sum);

// useEffect(fetchData, []);


// this.state = {
//     data:{},
// }

// const { data } = this.state;


    return (
      <div className={styles.container}>
          <div className={styles.container}>
            <section className={styles.two}>
                <div className={styles.two__justfy}>
                    <h1 className={styles.two__title}>Indonesia</h1>
                    <p className={styles.two__litle}>Data Covid Berdasarkan Global</p>
                </div>
            </section>


            <section className={styles.two}>
              {/* Looping card dengan file Card */}
              {/* Nanti diprops biar mudah tertata rapih data globalnya */}

               

                
         {/* {
                this.two.map(function(card) {
                    return <Card keys={card} />;

                })
            }    
                 */}


           {/* {
               cards.map((value) => {
                    return <Card keys={value} />
               })

           } */}


           <Card />
              
            


                {/* <div className={styles.two__justfy}>
                    <div className={styles.cards__items}>
                       <div className={styles.cards__one}>
                            <h1>{value.status}</h1>
                            <h1 className={styles.cards__descOne} value="">6.005.646</h1>
                        </div>

                    </div>

                    <div className={styles.cards__items}>
                        <div className={styles.cards__two}>
                            <h1>Dirawat</h1>
                            <h1 className={styles.cards__descTwo}>100.000</h1>
                        </div>
                    </div>

                    <div className={styles.cards__items}>
                        <div className={styles.cards__two}>
                            <h1>Meninggal</h1>
                            <h1 className={styles.cards__descThree}>10.000</h1>
                        </div>
                    </div>  


                </div>  */}
            </section>

           
      </div>
    </div>
    );
  }




export default Two;